import {
  canSampleAcceptUsageRecord,
  sampleUsageBlockReason,
  sampleUsageBlockShortLabel,
} from './sampleUsageRecords';

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export type SampleUsageActionUi =
  | { kind: 'button'; title: string }
  | { kind: 'blocked'; shortLabel: string; title: string };

/**
 * 一覧 HTML / ケース React 共通の「使用」スロット表示。
 * 使用不可は偽の disabled ボタンではなく状態チップにする。
 */
export function resolveSampleUsageActionUi(
  sample: {
    disposalDate?: string | null;
    remainingQuantity?: number | null;
  },
  options: {
    canManage: boolean;
    t: TranslateFn;
  }
): SampleUsageActionUi {
  const { canManage, t } = options;
  const canAdd = canSampleAcceptUsageRecord(sample);

  if (!canAdd) {
    const title = sampleUsageBlockReason(sample, t) ?? t('sample.cannot_add_usage');
    const shortLabel =
      sampleUsageBlockShortLabel(sample, t) ??
      t('sample.usage_blocked_depleted_short', { defaultValue: '残0' });
    return { kind: 'blocked', shortLabel, title };
  }

  if (!canManage) {
    return {
      kind: 'blocked',
      shortLabel: t('sample.usage_blocked_readonly_short', { defaultValue: '閲覧のみ' }),
      title: t('sample.case_manager.read_only_other_user'),
    };
  }

  return { kind: 'button', title: t('sample.add_usage_record') };
}
